/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */
import React, { Fragment } from 'react';
import { bool } from 'prop-types';
import { connect } from 'react-redux';

import {
  footerLinks,
  linkedBankAccountsLinks,
  updatedLinkedBankAccountsLinks
} from 'services/Externals';
import {
  hasAlaska529,
  hasMaryland529,
  hasMutualFunds,
  hasNational529,
  hasMaryland529Only,
  hasAlaska529Only,
  hasNational529Only,
  hasBrokerage,
  hasBrokerageAdvantageOnly,
  hasActivePlus,
  hasActiveAdvisory
} from 'state/view/ViewSelectors';
import { showFundsBoxInfo } from 'state/linkedBankAccounts/LinkedBankAccountsSelectors';
import { updatedBankingPageAccountFormsEnabled } from 'services/FeatureFlags';

const AddBankForm = ({ urlLink, formName}) => {
  return (
    <a href={urlLink} rel="noopener noreferrer" target="_blank">
      {formName}
    </a>
  );
};

const FundsBoxInfo = ({
  hasMutualFunds,
  hasNational529,
  hasMaryland529,
  hasAlaska529,
  hasMaryland529Only,
  hasAlaska529Only,
  hasNational529Only,
  showFundsBoxInfo,
  hasBrokerage,
  hasBrokerageAdvantageOnly,
  hasActivePlus,
  hasActiveAdvisory
}) => {
  let contactUsUrl = footerLinks.contactUsUrl;
  if (hasMaryland529Only) {
    contactUsUrl = footerLinks.maryland529.contactUsUrl;
  }
  if (hasAlaska529Only) {
    contactUsUrl = footerLinks.alaska529.contactUsUrl;
  }
  if (hasNational529Only) {
    contactUsUrl = footerLinks.national529.contactUsUrl;
  }

  return showFundsBoxInfo ? (
    <div className="info-box">
      <b>Some accounts cannot be linked with bank accounts online.</b>
      <p>
        Add bank accounts by mailing in the appropriate form and a voided check:
      </p>
      {updatedBankingPageAccountFormsEnabled() ? (
        <Fragment>
          {(hasMutualFunds ||
            hasBrokerage ||
            hasBrokerageAdvantageOnly ||
            hasActivePlus ||
            hasActiveAdvisory) && (
            <AddBankForm
              urlLink={updatedLinkedBankAccountsLinks.mutualFundForm}
              formName="Account Services Form"
            />
          )}
          {hasNational529 && (
            <AddBankForm
              urlLink={updatedLinkedBankAccountsLinks.national529Form}
              formName="T. Rowe Price College Savings Plan Account Services Form"
            />
          )}
          {hasMaryland529 && (
            <AddBankForm
              urlLink={updatedLinkedBankAccountsLinks.maryland529Form}
              formName="Maryland Senator Edward J. Kasemeyer College Investment Plan Account Services Form"
            />
          )}
          {hasAlaska529 && (
            <AddBankForm
              urlLink={updatedLinkedBankAccountsLinks.alaska529Form}
              formName="Alaska 529 Account Services Form"
            />
          )}
        </Fragment>
      ) : (
        <Fragment>
          {hasMutualFunds && (
            <AddBankForm
              urlLink={linkedBankAccountsLinks.mutualFundForm}
              formName="Mutual Fund Form"
            />
          )}
          {hasNational529 && (
            <AddBankForm
              urlLink={linkedBankAccountsLinks.national529Form}
              formName="T. Rowe Price College Savings Plan Form"
            />
          )}
          {hasMaryland529 && (
            <AddBankForm
              urlLink={linkedBankAccountsLinks.maryland529Form}
              formName="Maryland Senator Edward J. Kasemeyer College Investment Plan Form"
            />
          )}
          {hasAlaska529 && (
            <AddBankForm
              urlLink={linkedBankAccountsLinks.alaska529Form}
              formName="Alaska 529 Form"
            />
          )}
        </Fragment>
      )}
      <p>
        <b>Note:</b>&nbsp;In some cases, a signature guarantee for the Account
        Holder and all bank account owners may be necessary.
      </p>
      <hr />
      <p>
        <a href={contactUsUrl} rel="noopener noreferrer" target="_blank">
          Contact us
        </a>
        &nbsp;for help.
      </p>
    </div>
  ) : null;
};

FundsBoxInfo.propTypes = {
  hasMutualFunds: bool,
  hasNational529: bool,
  hasMaryland529: bool,
  hasAlaska529: bool,
  hasMaryland529Only: bool,
  hasAlaska529Only: bool,
  showFundsBoxInfo: bool,
  hasBrokerage: bool,
  hasBrokerageAdvantageOnly: bool,
  hasActivePlus: bool,
  hasActiveAdvisory: bool
};

FundsBoxInfo.defaultProps = {
  hasMutualFunds: false,
  hasNational529: false,
  hasMaryland529: false,
  hasAlaska529: false,
  hasMaryland529Only: false,
  hasAlaska529Only: false,
  showFundsBoxInfo: false,
  hasBrokerage: false,
  hasBrokerageAdvantageOnly: false,
  hasActivePlus: false,
  hasActiveAdvisory: false
};

const mapStateToProps = (state) => ({
  hasMutualFunds: hasMutualFunds(state),
  hasBrokerage: hasBrokerage(state),
  hasBrokerageAdvantageOnly: hasBrokerageAdvantageOnly(state),
  hasNational529: hasNational529(state),
  hasMaryland529: hasMaryland529(state),
  hasAlaska529: hasAlaska529(state),
  hasMaryland529Only: hasMaryland529Only(state),
  hasAlaska529Only: hasAlaska529Only(state),
  hasNational529Only: hasNational529Only(state),
  showFundsBoxInfo: showFundsBoxInfo(state),
  hasActivePlus: hasActivePlus(state),
  hasActiveAdvisory: hasActiveAdvisory(state)
});

export default connect(mapStateToProps)(FundsBoxInfo);
